import { IUser } from 'app/shared/model/user.model';

export interface ISurveillant {
  id?: any;
  firstName?: string;
  lastName?: string;
  matricule?: string;
  email?: string;
  telephone?: string;
  adresse?: string;
  login?: string;
  authorities?: any[];
  activated?: boolean;
  password?: string;
  ecoleId?: string;
}

export const defaultValue: Readonly<ISurveillant> = {
  id: null,
  firstName: '',
  lastName: '',
  matricule: '',
  email: '',
  telephone: '',
  adresse: '',
  login: '',
  password: '',
  activated: true,
  authorities: [],
  ecoleId: '',
};
